// ./modals/UserControlModal.js
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import moment from 'moment';

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import { fetchRatings, fetchReports, fetchBanLogs, fetchWarnLogs, reverseBan } from '../Api';
import React, { useState } from 'react';
const UserControlModal = ({ show, onClose, user, onAction }) => {
  const [selectedAction, setSelectedAction] = React.useState(null);
  const [reason, setReason] = React.useState('');

  const [showRatings, setShowRatings] = React.useState(false);
  const [ratings, setRatings] = React.useState([]);
  const [loadingRatings, setLoadingRatings] = React.useState(false);

  const [showReports, setShowReports] = React.useState(false);
  const [reports, setReports] = React.useState([]);
  const [loadingReports, setLoadingReports] = React.useState(false);
  const [totalReports, setTotalReports] = React.useState(0);
  const [selectedReporter, setSelectedReporter] = React.useState(null);
  const [banUntil, setBanUntil] = useState(null);
  const [confirmed, setConfirmed] = useState(false);



  const [banLogs, setBanLogs] = useState([]);
  const [loadingBanLogs, setLoadingBanLogs] = useState(false);
  const [showBanLogs, setShowBanLogs] = useState(false);




  const [warnLogs, setWarnLogs] = useState([]);
  const [loadingWarnLogs, setLoadingWarnLogs] = useState(false);
  const [showWarnLogs, setShowWarnLogs] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');




  if (!user) return null;







  const handleActionClick = (action) => {
    setSelectedAction(action);
  };


  const ACTION_TYPE_MAP = {
    Ban: 'ban',
    Delete: 'delete',
    Warning: 'warn', // ✅ Fixes the mismatch
  };

  const handleSubmitAction = () => {
    if (!reason.trim()) {
      alert('Please provide a reason.');
      return;
    }

    const action_type = ACTION_TYPE_MAP[selectedAction];

    if (!action_type) {
      alert('Invalid action type.');
      return;
    }

    if (action_type === 'ban' && !banUntil) {
      alert('Please select a ban until date.');
      return;
    }

    let formattedBanUntil = null;
    if (action_type === 'ban' && banUntil) {
      // Convert local datetime string to UTC ISO format
      const date = new Date(banUntil);
      formattedBanUntil = date.toISOString();
      // e.g. "2025-08-25T07:40:23.954Z"
    }

    onAction?.({
      target_user_id: user.id,
      action_type,
      reason: reason.trim(),
      ban_expires_at: formattedBanUntil,
    });

    setSelectedAction(null);
    setReason('');
    setBanUntil('');
    onClose();
  };



  const handleClose = () => {
    setShowRatings(false);
    setShowReports(false);
    setSelectedReporter(null);
    setSelectedAction(null);
    setRatings([]);
    setReports([]);

    setBanLogs([]);
    setShowBanLogs(false);
    setLoadingBanLogs(false);




    setWarnLogs([]);
    setShowWarnLogs(false);
    setLoadingWarnLogs(false);




    onClose();
  };





  return (


    <div
      className={`modal fade ${show ? 'show d-block' : ''}`}
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
    >
      {/* Minimalist white background, black font */}
      <style>
        {`
          .modal-content,
          .modal-content * {
            color: #111 !important;
            background: #fff !important;
            border-color: #222 !important;
          }
          .modal-content .btn,
          .modal-content .btn-outline-secondary,
          .modal-content .btn-outline-danger,
          .modal-content .btn-outline-dark,
          .modal-content .btn-outline-warning,
          .modal-content .btn-link,
          .modal-content .btn-secondary,
          .modal-content .btn-primary {
            color: #111 !important;
            background: #fff !important;
            border-color: #222 !important;
          }
          .modal-content .btn-primary,
          .modal-content .btn-danger,
          .modal-content .btn-warning {
            background: #111 !important;
            color: #fff !important;
            border-color: #111 !important;
          }
          .modal-content .form-control,
          .modal-content .form-label {
            color: #111 !important;
            background: #f7f7f7 !important;
            border-color: #222 !important;
          }
          .modal-content .list-group-item {
            background: #f7f7f7 !important;
            border-color: #eee !important;
            color: #111 !important;
          }
          .modal-content .text-muted,
          .modal-content small.text-muted {
            color: #666 !important;
          }
          .modal-content .text-primary {
            color: #111 !important;
          }
          .modal-content .bg-light {
            background: #f7f7f7 !important;
          }
          .modal-content .table th,
          .modal-content .table td {
            border-color: #eee !important;
            color: #111 !important;
          }
          .modal-content .rdtPicker {
            background: #fff !important;
            border-radius: 8px;
          }
          .modal-content .rdtPicker td,
          .modal-content .rdtPicker th,
          .modal-content .rdtDay,
          .modal-content .rdtHour,
          .modal-content .rdtMinute,
          .modal-content .rdtSecond {
            color: #111 !important;
          }
          .modal-content .rdtPicker .rdtActive {
            background: #111 !important;
            color: #fff !important;
            border-radius: 4px;
          }
          .modal-content .rdtPicker .rdtDay:hover {
            background: #222 !important;
            color: #fff !important;
          }
          .modal-content .bi-star,
          .modal-content .bi-star-fill,
          .modal-content .bi-star-half {
            color: #111 !important;
          }
        `}
      </style>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow" style={{ background: '#fff', borderRadius: '8px' }}>
          <div className="modal-body p-4" style={{ background: 'transparent', color: '#111' }}>

            <div className="d-flex justify-content-between align-items-start mb-3">
              {/* Hide action buttons if any action is selected */}
              {!selectedAction && (


                <div className="d-flex gap-3">
                  <div className="d-flex">
                    <button
                      className="btn btn-outline-secondary btn-sm me-2"
                      style={{
                        backgroundColor: 'rgb(252 137 0)'
                      }}
                      onClick={async () => {
                        setShowRatings(true);
                        setShowReports(false);
                        setSelectedReporter(null);
                        setLoadingRatings(true);
                        try {
                          const data = await fetchRatings({ user_id: user.id });
                          await new Promise((resolve) => setTimeout(resolve, 500)); // 0.5s delay
                          setRatings(data);
                        } catch (err) {
                          console.error('Failed to fetch ratings:', err);
                        } finally {
                          setLoadingRatings(false);
                        }
                      }}
                    >
                      Ratings
                    </button>


                    <button
                      className="btn btn-outline-danger btn-sm"
                      style={{
                        backgroundColor: 'rgb(252 137 0)'
                      }}
                      onClick={async () => {
                        setShowReports(true);
                        setShowRatings(false);
                        setSelectedReporter(null);
                        setLoadingReports(true);

                        try {
                          const data = await fetchReports(user.id);
                          // artificial delay 0.5s
                          await new Promise((resolve) => setTimeout(resolve, 500));
                          setTotalReports(data.total_reports || 0);
                          setReports(data.reports || []);
                        } catch (err) {
                          console.error('Failed to fetch reports:', err);
                        } finally {
                          setLoadingReports(false);
                        }
                      }}
                    >
                      Reports
                    </button>
                  </div>

                  <div className="d-flex">

                    {/* Ban Logs Button */}
                    <button
                      className="btn btn-outline-dark btn-sm me-2"
                      style={{
                        backgroundColor: 'rgb(252 137 0)'
                      }}
                      onClick={async () => {
                        setShowBanLogs(true);
                        setShowReports(false);
                        setShowRatings(false);
                        setLoadingBanLogs(true);
                        try {
                          const data = await fetchBanLogs(user.id);
                          await new Promise((resolve) => setTimeout(resolve, 500)); // 0.5s delay
                          setBanLogs(data || []);
                        } catch (err) {
                          console.error('Failed to fetch ban logs:', err);
                        } finally {
                          setLoadingBanLogs(false);
                        }
                      }}
                    >
                      Ban Logs
                    </button>

                    {/* Warning Logs Button */}
                    <button
                      className="btn btn-outline-warning btn-sm"
                      style={{
                        backgroundColor: 'rgb(252 137 0)'
                      }}
                      onClick={async () => {
                        setShowWarnLogs(true);
                        setShowBanLogs(false);
                        setShowReports(false);
                        setShowRatings(false);
                        setLoadingWarnLogs(true); // <-- FIXED: was missing closing parenthesis
                        try {
                          const data = await fetchWarnLogs(user.id);
                          await new Promise((resolve) => setTimeout(resolve, 500)); // 0.5s delay
                          setWarnLogs(data || []);
                        } catch (err) {
                          console.error('Failed to fetch warning logs:', err);
                        } finally {
                          setLoadingWarnLogs(false);
                        }
                      }}
                    >
                      Warning Logs
                    </button>



                  </div>
                </div>

              )}

              {!selectedAction && (
                <button
                  className="btn btn-link p-0"
                  onClick={handleClose}
                  style={{ textDecoration: 'none' }}
                >
                  Close
                </button>
              )}

            </div>

            {selectedAction ? (




              <div>



                <h5 className="fw-bold mb-3 text-capitalize">Confirm {selectedAction}</h5>



                {/* Ban Until field (only for Ban) */}
                {selectedAction === 'Ban' && (
                  <div className="mb-3">
                    <label className="form-label">Ban Until</label>

                    <>
                      <style>
                        {`
    .modal-content .rdtPicker {
      background-color: #ff9b54; /* 🔶 orange background */
      border-radius: 8px;
    }

    .modal-content .rdtPicker td,
    .modal-content .rdtPicker th,
    .modal-content .rdtDay,
    .modal-content .rdtHour,
    .modal-content .rdtMinute,
    .modal-content .rdtSecond {
      color: #000000 !important; /* ⚫ black font */
    }

    .modal-content .rdtPicker .rdtActive {
      background-color: #000000 !important; /* black highlight */
      color: #ffffff !important;            /* white text */
      border-radius: 4px;
    }

    .modal-content .rdtPicker .rdtDay:hover {
      background-color: #333333 !important; /* dark hover */
      color: #ffffff !important;
    }
  `}
                      </style>

                      <Datetime
                        value={banUntil ? moment(banUntil) : null}
                        onChange={(val) => {
                          if (moment.isMoment(val) && val.isValid()) {
                            setBanUntil(val); // Keep as moment object
                            setConfirmed(false);
                            setErrorMessage('');
                          } else {
                            setBanUntil(null);
                          }
                        }}
                        dateFormat="YYYY-MM-DD"
                        timeFormat="HH:mm"
                        input={false}
                        closeOnSelect={false}
                        isValidDate={(current) => current.isSameOrAfter(moment(), 'day')}
                        timeConstraints={{
                          hours: { min: (date) => (moment(date).isSame(moment(), 'day') ? moment().hour() : 0) },
                          minutes: { min: (date) => (moment(date).isSame(moment(), 'day') ? moment().minute() : 0) }
                        }}
                      />
                    </>
                    {banUntil && (
                      <div className="mt-2 text-muted">
                        Selected: <strong>{new Date(banUntil).toLocaleString()}</strong>
                      </div>
                    )}

                    {errorMessage && (
                      <div className="alert alert-danger mt-2">{errorMessage}</div>
                    )}


                    {!confirmed && (
                      <button
                        className="btn btn-sm btn-primary mt-2"
                        onClick={() => {
                          if (!banUntil || !banUntil.isValid()) {
                            setErrorMessage("Pick a valid date first");
                            return;
                          }

                          const now = moment();
                          if (banUntil.isBefore(now)) {
                            setErrorMessage("Ban until cannot be in the past! Pick a future time.");
                            return;
                          }

                          setBanUntil(banUntil.toISOString()); // Convert to ISO only once
                          setConfirmed(true);
                          setErrorMessage('');
                        }}
                      >
                        Done
                      </button>


                    )}
                  </div>
                )}




                <label className="form-label">Reason for {selectedAction}</label>
                <textarea
                  className="form-control mb-3"
                  rows="4"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder={`Enter reason for ${selectedAction.toLowerCase()}...`}
                />
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-secondary me-2"
                    onClick={() => {
                      setSelectedAction(null);
                      setReason('');
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleSubmitAction}
                    disabled={selectedAction === 'Ban' && !confirmed} // Disable until Done clicked
                    title={selectedAction === 'Ban' && !confirmed ? "Pick a date and click Done first" : ""}
                  >
                    Confirm {selectedAction}
                  </button>
                </div>


              </div>
            ) : showRatings ? (




              <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0">User Ratings</h5>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setShowRatings(false)}
                  >
                    Back
                  </button>
                </div>

                {loadingRatings ? (
                  <div>Loading ratings...</div>
                ) : ratings.length === 0 ? (
                  <div>No ratings available.</div>
                ) : (


                  <ul className="list-group">
                    {ratings.map((entry) => (
                      <li
                        key={entry.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <span>{entry.rator_name || 'Anonymous'}</span>
                        <span>
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={`bi ${i < entry.rating ? 'bi-star-fill' : 'bi-star'
                                } text-warning`}
                            ></i>
                          ))}
                        </span>
                      </li>
                    ))}
                  </ul>



                )}
              </div>
            ) :


              showReports ? (
                <div>
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">Reports ({totalReports})</h5>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setShowReports(false)}
                    >
                      Back
                    </button>
                  </div>

                  {/* Loading / Empty States */}
                  {loadingReports ? (
                    <div className="text-muted">Loading reports...</div>
                  ) : reports.length === 0 ? (
                    <div className="text-muted">No reports available.</div>
                  ) : (
                    // Main Report Section
                    <div
                      className="border rounded p-3 row"
                      style={{ maxHeight: '400px', overflow: 'hidden' }}
                    >
                      {/* Left: Reporter list - reduced width */}
                      <div className="col-md-4 border-end pe-3" style={{ overflowY: 'auto' }}>
                        <h6 className="fw-semibold mb-3">Reporters</h6>
                        <ul className="list-group list-group-flush">
                          {reports.map((report, idx) => (
                            <li key={idx} className="list-group-item py-2">
                              <div
                                className="fw-bold text-primary"
                                role="button"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setSelectedReporter(report.reporter_name)}
                              >
                                {report.reporter_name || 'Anonymous'}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Right: Selected reporter's full report box - increased width */}
                      {selectedReporter && (
                        <div className="col-md-8 ps-3" style={{ overflowY: 'auto' }}>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold mb-0">
                              {selectedReporter}
                              {/* Show created_at date beside user */}
                              {(() => {
                                const firstMatch = reports.find((r) => r.reporter_name === selectedReporter);
                                return firstMatch ? (
                                  <small className="text-muted ms-2">
                                    {new Date(firstMatch.created_at).toLocaleString()}
                                  </small>
                                ) : null;
                              })()}
                            </h6>
                          </div>

                          <ul className="list-group list-group-flush">
                            {reports
                              .filter((r) => r.reporter_name === selectedReporter)
                              .map((r, idx) => (
                                <li key={idx} className="list-group-item py-2">
                                  <p className="mb-1">{r.content}</p>
                                  <small className="text-muted">
                                    {new Date(r.created_at).toLocaleString()}
                                  </small>
                                </li>
                              ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>


              ) :
                showBanLogs ? (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="fw-bold mb-0">Ban Logs</h5>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => setShowBanLogs(false)}
                      >
                        Back
                      </button>
                    </div>

                    {loadingBanLogs ? (
                      <div className="text-muted">Loading ban logs...</div>
                    ) : banLogs.length === 0 ? (
                      <div className="text-muted">No ban logs available.</div>
                    ) : (
                      <div className="border rounded p-3" style={{ maxHeight: "400px", overflowY: "auto" }}>


                        {banLogs.map((entry, idx) => (
                          <div key={idx} className="mb-3">
                            <h6 className="fw-bold">{entry.admin_name} → {entry.target_user}</h6>
                            <small className="text-muted">Action: {entry.action_type}</small>
                            <ul className="list-group list-group-flush mt-2">
                              {entry.logs.map((log, i) => (
                                <li
                                  key={i}
                                  className="list-group-item py-2 d-flex justify-content-between align-items-start"
                                >
                                  <div>
                                    <p className="mb-1">Reason: {log.reason}</p>
                                    <p className="mb-1">
                                      Ban Expires: {log.ban_expires_at ? new Date(log.ban_expires_at).toLocaleString() : "N/A"}
                                    </p>
                                    <small className="text-muted">
                                      Created At: {new Date(log.created_at).toLocaleString()}
                                    </small>
                                  </div>
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={async () => {
                                      try {
                                        const action_id = entry.logs[0].id; // Assuming the action_id is the id of the first log
                                        const response = await reverseBan(action_id);
                                        console.log(response); // Handle the response as needed

                                        onClose();

                                      } catch (error) {
                                        console.error(error); // Handle the error as needed
                                      }
                                    }}
                                  >
                                    Delete
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}



                      </div>
                    )}
                  </div>
                ) :

                  showWarnLogs ? (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold mb-0">Warning Logs</h5>
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => setShowWarnLogs(false)}
                        >
                          Back
                        </button>
                      </div>

                      {loadingWarnLogs ? (
                        <div className="text-muted">Loading warning logs...</div>
                      ) : warnLogs.length === 0 ? (
                        <div className="text-muted">No warning logs available.</div>
                      ) : (
                        <div className="border rounded p-3" style={{ maxHeight: "400px", overflowY: "auto" }}>
                          {warnLogs.map((entry, idx) => (
                            <div key={idx} className="mb-3">
                              <h6 className="fw-bold">{entry.admin_name} → {entry.target_user}</h6>
                              <small className="text-muted">Action: {entry.action_type}</small>
                              <ul className="list-group list-group-flush mt-2">
                                {entry.logs.map((log, i) => (
                                  <li key={i} className="list-group-item py-2">
                                    <p className="mb-1">Reason: {log.reason}</p>
                                    <small className="text-muted">
                                      Created At: {new Date(log.created_at).toLocaleString()}
                                    </small>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )




                    : (
                      // Default Full Modal UI
                      <>
                        <div className="d-flex align-items-center mb-3">


                          <div className="me-3">
                            {user.profile_image?.trim() ? (
                              <img
                                src={`${user.profile_image}?t=${Date.now()}`} // cache-busting
                                alt={user.full_name || "Profile"}
                                className="rounded-circle object-fit-cover bg-light"
                                style={{ width: "64px", height: "64px" }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null; // prevent infinite loop
                                  e.currentTarget.style.display = "none"; // hide broken image
                                }}
                              />
                            ) : (
                              <div
                                className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
                                style={{
                                  width: "64px",
                                  height: "64px",
                                  fontSize: "24px",
                                  fontWeight: "bold",
                                }}
                              >
                                {user.full_name
                                  ? user.full_name
                                    .split(" ")
                                    .map((n) => n[0])
                                    .join("")
                                    .slice(0, 2)
                                    .toUpperCase()
                                  : "U"}
                              </div>
                            )}
                          </div>



                          <div>
                            <h5 className="mb-1">
                              {user.full_name}{' '}
                              <span className={user.is_active ? "text-success" : "text-muted"}>
                                | {user.is_active ? "Active" : "Inactive"}
                              </span>

                              {user.is_banned && (
                                <span className="text-danger">| Banned</span>
                              )}


                            </h5>


                            <small className="text-muted">
                              {user.age} | {user.gender} | {(user.height)}ft. | {user.weight} kg. |{' '}
                              {user.location || 'Unknown'}
                            </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center mb-3">
                          <span className="me-2 fw-bold">{user.avg_rating ?? 'N/A'}</span>
                          <div>
                            {Array.from({ length: 5 }).map((_, i) => {
                              const rating = user.avg_rating ?? 0;
                              if (i + 1 <= Math.floor(rating)) {
                                return <i key={i} className="bi bi-star-fill text-warning"></i>;
                              } else if (i < rating && rating < i + 1) {
                                return <i key={i} className="bi bi-star-half text-warning"></i>;
                              } else {
                                return <i key={i} className="bi bi-star text-warning"></i>;
                              }
                            })}
                          </div>
                        </div>

                        <div className="mb-4 d-grid gap-2">
                          <button className="btn btn-outline-dark" style={{ borderColor: '#FFECC8', background: 'transparent' }} onClick={() => handleActionClick('Ban')}>
                            Ban
                          </button>
                          <button
                            className="btn btn-outline-danger" style={{ borderColor: '#FFECC8', background: 'transparent' }}
                            onClick={() => handleActionClick('Delete')}
                          >
                            Delete
                          </button>
                          <button
                            className="btn btn-outline-warning" style={{ borderColor: '#FFECC8', background: 'transparent' }}
                            onClick={() => handleActionClick('Warning')}
                          >
                            Send Warning
                          </button>
                        </div>




                        <div className="bg-light p-3 rounded">
                          <h6 className="fw-bold mb-3">Scoreboard</h6>
                          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <table className="table table-borderless mb-0 text-center">
                              <thead className="position-sticky top-0 bg-light">
                                <tr>
                                  <th>Sports</th>
                                  <th>Score</th>
                                  <th>Tier</th>
                                </tr>
                              </thead>
                              <tbody>
                                {user.sports?.map((sport, index) => (
                                  <tr key={index}>
                                    <td>{sport.sport_name ?? '-'}</td>
                                    <td>{sport.sport_score ?? '-'}</td>
                                    <td>{sport.tier_name ?? '-'}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>



                      </>

                    )}
          </div>
        </div>
      </div>
    </div >



  );

};

export default UserControlModal;
